/* eslint-disable */
/// This file is auto generated - do not edit manually
export const Cancelled = 'Website.Booking.Shared.BookingStatus.Cancelled';
export const UserWasAbsent = 'Website.Booking.Shared.BookingStatus.UserWasAbsent';
